import React from "react";
import styled from "@emotion/styled";
import { Grid, Typography, Link } from "@mui/material";
import FooterLogo from "../assets/logoWhite.svg";

export default function Footer() {
  const today = new Date();

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent={{ xs: "center", sm: "space-between" }}
        alignItems="center"
        bgcolor="rgb(23,40,56)"
        p="2rem 4rem"
      >
        <Grid item p={"1rem"} align="center">
          <Link href="https://thekahanoffcentre.com/" target="Kahanoff">
            <Logo src={FooterLogo} width="200" height="auto" />
          </Link>
        </Grid>
        {/* TODO add the site map */}
        <Grid item xs={12} sm={6} align={"left"}>
          <Typography
            variant="h5"
            style={{ color: "#9a9a9a" }}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            Land Recognition
          </Typography>
          <Typography
            variant="body1"
            color="common.white"
            sx={{ fontSize: { xs: "12px" }, textAlign: { xs: "center", md: "left" } }}
          >
            In the spirit of reconciliation, we acknowledge that we live, work and play on the
            traditional territories of the Blackfoot Confederacy (Siksika, Kainai, Piikani), the
            Tsuut’ina, the Îyâxe Nakoda Nations, the Métis Nation (Region 3), and all people who
            make their homes in the Treaty 7 region of Southern Alberta.
          </Typography>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} bgcolor="common.black" align="center" p={".5rem 0"}>
          <Typography color="common.white" fontSize={{ xs: ".625rem" }}>
            ©{today.getFullYear()} The Kanahoff Centre. All Rights Reserved.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

const Logo = styled("img")`
  padding-bottom: 2rem;
  ${props => props.theme.breakpoints.up("sm")} {
    padding-bottom: unset;
  }
`;
